import { render, staticRenderFns } from "./emaillist.vue?vue&type=template&id=27b23128&scoped=true&"
import script from "./emaillist.vue?vue&type=script&lang=js&"
export * from "./emaillist.vue?vue&type=script&lang=js&"
import style0 from "./emaillist.vue?vue&type=style&index=0&id=27b23128&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b23128",
  null
  
)

export default component.exports